import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useReducer } from "react";
import useCurrentApiUser from "../../Hooks/useCurrentApiUser";
import { PopulationFolderOpenStorageService } from "../../../Services/Shared/LocalStorage.service";
const reducer = (state, action) => {
    switch (action.type) {
        case "OPEN_FOLDERS":
            return state.concat(action.payload.filter((id) => !state.includes(id)));
        case "CLOSE_FOLDERS":
            return state.filter((id) => !action.payload.includes(id));
        case "TOGGLE_FOLDERS": {
            const set = new Set(state);
            action.payload.forEach((id) => {
                if (set.has(id)) {
                    set.delete(id);
                }
                else {
                    set.add(id);
                }
            });
            return Array.from(set);
        }
        case "CLOSE_ALL":
            return [];
        case "RESET":
            return action.payload;
        default:
            return state;
    }
};
const INITIAL_STATE = [];
const getQuestions = (state) => ({
    isOpen: (folderId) => state.includes(folderId),
    isClosed: (folderId) => !state.includes(folderId),
});
const getContextActions = (dispatch) => ({
    openFolders: (folderIds) => {
        dispatch({ type: "OPEN_FOLDERS", payload: folderIds });
    },
    openFolder: (folderId) => {
        dispatch({ type: "OPEN_FOLDERS", payload: [folderId] });
    },
    closeFolders: (folderIds) => {
        dispatch({ type: "CLOSE_FOLDERS", payload: folderIds });
    },
    closeFolder: (folderId) => {
        dispatch({ type: "CLOSE_FOLDERS", payload: [folderId] });
    },
    toggleFolders: (folderIds) => {
        dispatch({ type: "TOGGLE_FOLDERS", payload: folderIds });
    },
    toggleFolder: (folderId) => {
        dispatch({ type: "TOGGLE_FOLDERS", payload: [folderId] });
    },
    closeAllFolders: () => {
        dispatch({ type: "CLOSE_ALL", payload: undefined });
    },
});
const FolderStateContext = React.createContext(
// @ts-expect-error this will be defined right away, so we'll ignore it's an empty object for now.
{});
export const FolderStateContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, INITIAL_STATE);
    const value = React.useMemo(() => (Object.assign(Object.assign({}, getContextActions(dispatch)), getQuestions(state))), [state]);
    const currentUser = useCurrentApiUser();
    React.useEffect(() => {
        var _a;
        if (currentUser) {
            dispatch({
                type: "RESET",
                payload: (_a = PopulationFolderOpenStorageService.get(currentUser.id)) !== null && _a !== void 0 ? _a : [],
            });
        }
    }, [currentUser]);
    React.useEffect(() => {
        // synchronize state to local storage
        if (currentUser) {
            PopulationFolderOpenStorageService.set(currentUser.id, state);
        }
    }, [currentUser, state]);
    return (_jsx(FolderStateContext.Provider, { value: value, children: children }));
};
export const useFolderState = () => useContext(FolderStateContext);
